import React, { useEffect } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';

import { fetchVoicemailSettings } from 'flow/actions/voicemail-actions';
import Page from 'flow/components/Setting/Page';
import EditVoicemailLogin from 'flow/components/Setting/Voicemail/EditVoicemailLogin';
import Loading from 'flow/components/ui-components/Loading';
import useVoicemail from 'flow/hooks/useVoicemail';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

const SettingsVoicemailLogin = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const { voicemailSettings } = useVoicemail(extensionKey);

    useEffect(() => {
        if (!voicemailSettings) {
            dispatch(fetchVoicemailSettings(extensionKey));
        }
    }, [extensionKey]);

    return (
        <Page
            header="settings.voicemail_login"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.voicemail'], {
                        extensionKey,
                    }),
                )
            }
        >
            {voicemailSettings ? (
                <EditVoicemailLogin extensionKey={extensionKey} />
            ) : (
                <Loading />
            )}
        </Page>
    );
};

export default SettingsVoicemailLogin;
